/**
 * 公共部分
 */
import { Outlet } from 'react-router-dom';

import Header from "@/components/Header"
import Footer from "@/components/Footer"
import './index.scss'
import { useEffect, useState } from 'react';

const Layout = () => {
  const [showHeader, setShowHeader] = useState(true);
  const [lastScrollY, setLastScrollY] = useState(0);
  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;

      // 向下滚动且滚动超过 50px，就隐藏
      if (currentScrollY > lastScrollY && currentScrollY > 50) {
        setShowHeader(false);
      }
      // 向上滚动则显示
      else if (currentScrollY < lastScrollY) {
        setShowHeader(true);
      }

      setLastScrollY(currentScrollY);
    };

    window.addEventListener('scroll', handleScroll);

    return () => window.removeEventListener('scroll', handleScroll);
  }, [lastScrollY]);
 return (
  <div>
    <Header />

    <Outlet />

    <Footer />
  </div>
 )
}

export default Layout